// extracted by mini-css-extract-plugin
module.exports = {"controlRowsNum":"style_controlRowsNum__MPAMy"};